module.exports = __webpack_public_path__ + "8222c72e.png";